import {EqualityFn, useDispatch, useSelector} from 'react-redux';

import {CommonAppAction} from './commonAppAction';
import {CommonAppSelector} from './commonAppSelectorTypes';
import {CommonAppState} from './commonAppState';
import {CommonAppStore} from './commonAppStore';

export const useCommonAppDispatch = () =>
  useDispatch<CommonAppStore<CommonAppState, CommonAppAction>['dispatch']>();

export const useCommonAppSelector: <State extends CommonAppState, Result>(
  selector: CommonAppSelector<State, Result>,
  equalityFn?: EqualityFn<Result> | undefined,
) => Result = useSelector;
